import { RouteObject } from "react-router-dom"
import MembershipType from '../components/membershipAndMarketing/membershipCenter/MembershipType';
import MembershipLevel from '../components/membershipAndMarketing/membershipCenter/MembershipLevel';
import MembershipInfo from '../components/membershipAndMarketing/membershipCenter/MembershipInfo';
import Membership from '../components/membershipAndMarketing/membershipCenter/Membership';
import MembershipMarketingPlans from '../components/membershipAndMarketing/membershipCenter/MembershipMarketingPlans';
import MembershipMarketingDetails from '../components/membershipAndMarketing/membershipCenter/MembershipMarketingDetails';
import MembershipCarePlans from '../components/membershipAndMarketing/membershipCenter/MembershipCarePlans';
import MembershipRechargePlans from '../components/membershipAndMarketing/membershipCenter/MembershipRechargePlans';
import MembershipPointsPlans from '../components/membershipAndMarketing/membershipCenter/MembershipPointsPlans';
import MembershipRechargeLockRules from '../components/membershipAndMarketing/membershipCenter/MembershipRechargeLockRules';

import GiftCardPlans from '../components/membershipAndMarketing/marketingCenter/GiftCardPlans';
import GiftCard from '../components/membershipAndMarketing/marketingCenter/GiftCard';

const membershipRouters: RouteObject[] = [
    {
        path: "/membershipType",
        element: <MembershipType />,
    },
    {
        path: "/membershipLevel",
        element: <MembershipLevel />,
    },
    {
        path: "/membershipInfo",
        element: <MembershipInfo />,
    },
    {
        path: "/membership",
        element: <Membership />,
    },
    {
        path: "/membershipMarketingPlans",
        element: <MembershipMarketingPlans />,
    },
    {
        path: "/membershipMarketingDetails",
        element: <MembershipMarketingDetails />,
    },
    {
        path: "/membershipCarePlans",
        element: <MembershipCarePlans />,
    },
    {
        path: "/membershipRechargePlans",
        element: <MembershipRechargePlans />,
    },
    {
        path: "/membershipPointsPlans",
        element: <MembershipPointsPlans />,
    },
    {
        path: "/membershipRechargeLockRules",
        element: <MembershipRechargeLockRules />,
    },
    {
        path: "/giftCardPlans",
        element: <GiftCardPlans />,
    },
    {
        path: "/giftCard",
        element: <GiftCard />,
    }

];


export default membershipRouters;